/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useInputValue } from '../../utils/hooks/useInputValue';
import { Utils, Teams, Auth, User } from '../../utils/api';
import { ARMcontext } from '../../utils/context/context';
import { PasswordModal } from './'
import {
  Navbar,
  FluidContainer,
  Badge,
  LargeButton,
  Label,
  InputComponent,
  PowerDropdown,
  BadgeImage,
  Modal,
  Loader,
  ToolTip,
  VideoTourModal
} from '../../components';
import {
  CRightTop,
  ConfigCard,
  CLeftInputs,
  CLeftBadges,
  CLeftActions,
  CRightBottom,
  ConfigWrapper,
  ConfigCardLeft,
  ConfigCardRight,
  CLeftActionInfo,
  CLeftInputSection,
  CRightInputWrapper,
  CRightPasswordWrapper,
  InputWrapper,
  TopWrapper,
  BottomWrapper,
} from './styles';

const DEFAULT_ORG_TYPES = [
  { name: 'Training Facility' },
  { name: 'Professional Organization' },
  { name: 'College / University' },
  { name: 'High School' },
  { name: 'Travel Baseball' },
  { name: 'Other' }
]
const DefaultStates = [{ name: 'CO' }, { name: 'KA' }, { name: 'WS' }];
const DefaultPallette = [
  { badge: 'NULL', color: 'rgba(253,185,18,1)', title: '' },
  { badge: 'NULL', color: 'rgba(253,139,18,1)', title: '' },
  { badge: 'NULL', color: 'rgba(207,153,95,1)', title: '' },
  { badge: 'NULL', color: 'rgba(150,60,21,1)', title: '' },
  { badge: 'NULL', color: 'rgba(80,180,128,1)', title: '' },
  { badge: 'NULL', color: 'rgba(132,192,193,1)', title: '' },
  { badge: 'NULL', color: 'rgba(62,174,242,1)', title: '' },
  { badge: 'NULL', color: 'rgba(32,121,194,1)', title: '' },
  { badge: 'NULL', color: 'rgba(71,55,255,1)', title: '' },
  { badge: 'NULL', color: 'rgba(102,124,255,1)', title: '' },
  { badge: 'NULL', color: 'rgba(156,85,239,1)', title: '' },
  { badge: 'NULL', color: 'rgba(126,73,184,1)', title: '' },
  { badge: 'NULL', color: 'rgba(240,120,255,1)', title: '' },
  { badge: 'NULL', color: 'rgba(248,73,88,0.9)', title: '' },
  { badge: 'NULL', color: 'rgba(255,94,85,1)', title: '' },
  { badge: 'NULL', color: 'rgba(97,99,102,1)', title: '' },
  { badge: 'NULL', color: 'rgba(26,57,92,1)', title: '' },
];
export default () => {
  const teamLogoRef = useRef<HTMLInputElement | any>(document.createElement('input'));
  const [defaultStates, useDefaultStates] = useState<any>(DefaultStates);
  const { HandleToastMessage, HandleUser, user } = React.useContext(ARMcontext);
  const [states, useStates] = useState<any>(user.data?.state ? { name: user.data.state } : { name: user.data.organization.state });
  const [city] = useState<any>(user.data?.city ? { name: user.data?.city } : { name: user.data?.organization?.city });
  const [orgType, useOrgType] = useState<any>(user.data?.orgType2 ? { name: user?.data?.orgType2 } : { name: user?.data?.organization?.orgType2 });
  const [image, useImage] = useState<any>('');
  const [modal, useModal] = useState(false);
  const [isVideoTour, setVideoTour] = useState(user.data?.isFirstLogin || false);
  const [loading, useLoading] = useState(false);
  const [formFilled, useFormFilled] = useState(false);
  const [pallette, usePallette] = useState<any>(
    user?.data?.organization?.color !== null ? { color: user?.data?.organization?.color, badge: 'NULL' } : DefaultPallette[0],
  );
  const PasswordInput = useInputValue('', '', 'disabled', '', 'password');
  const EmailInput = useInputValue(user.data ? user.data.email : '');
  const OrganizationInput = useInputValue(
    user.data?.isFirstLogin ? '' : user.data.organization.name ? user.data.organization.name : '',
  );
  const TeamBadge = useInputValue(
    user.data?.organization?.initials ? user.data.organization.initials.slice(0, 2) : user.data.firstName.slice(0, 2),
  );
  const PhoneInput = useInputValue(user.data.phone ? user.data.phone : '');
  const CityInput = useInputValue(user.data.city ? user.data.city : city.name);
  const FNameInput = useInputValue(user.data ? user.data.firstName : '');
  const LNameInput = useInputValue(user.data ? user.data.lastName : '');
  const [error, useError] = useState(false);
  const initialName = user.data ? '' : 'Organization Name';
  const utils = new Utils();
  const TEAMS = new Teams();
  const AUTH = new Auth();
  const USER = new User();
  const validateEmail = utils.GetValidationEmailPattern();
  const validatePhone = utils.GetValidationPhonePattern();
  const validateInput = utils.GetValidationInputPattern();
  const validateAlphaNumeric = utils.GetValidationWordsAndNumbers();

  useEffect(() => {
    BuildStates();
  }, []);

  useEffect(() => {
    handleDone();
  }, [image]);

  useEffect(() => {
    TeamBadge.HandleValue(TeamBadge?.value?.toUpperCase() || '');
  }, [TeamBadge.value]);
  

  useEffect(() => {
    let error = 0;
    !validatedEmail() && error++;
    !validatedFirstName() && error++;
    !validatedLastName() && error++;
    !validatedPhone() && error++;
    !validatedCity() && error++;
    !validatedOrgType() && error++;

    if (user.role === 'org-admin') {
    
      if (OrganizationInput.value === initialName && user.data?.isFirstLogin && user.role === 'org-admin') {
        OrganizationInput.HandleWarning('Please change the initial organization name');
        OrganizationInput.HandleStatus('error');
        error++;
      }
      !validatedOrg() && error++;

      formFilledOrg();
    } else {
      formFilledCoach();
    }

    if (error === 0) {
      useError(false);
    } else {
      useError(true);
    }
  }, [FNameInput.value, LNameInput.value, EmailInput.value, PhoneInput.value, CityInput.value, OrganizationInput.value]);

  function validatedEmail(): boolean {
    if (Number(EmailInput.value.length) === 0 || !Boolean(validateEmail.test(EmailInput.value))) {
      EmailInput.HandleWarning('Please enter a valid email');
      EmailInput.HandleStatus('error');
      return false;
    } else {
      EmailInput.HandleWarning('');
      EmailInput.HandleStatus('normal');
      return true;
    }
  }
  function validatedFirstName(): boolean {
    if (Number(FNameInput.value.length) === 0 || !Boolean(validateInput.test(FNameInput.value))) {
      FNameInput.HandleWarning('Please enter a valid first name');
      FNameInput.HandleStatus('error');
      return false;
    } else {
      FNameInput.HandleWarning('');
      FNameInput.HandleStatus('normal');
      return true;
    }
  }
  function validatedLastName(): boolean {
    if (Number(LNameInput.value.length) === 0 || !Boolean(validateInput.test(LNameInput.value))) {
      LNameInput.HandleWarning('Please enter a valid last name');
      LNameInput.HandleStatus('error');
      return false;
    } else {
      LNameInput.HandleWarning('');
      LNameInput.HandleStatus('normal');
      return true;
    }
  }
  function validatedPhone(): boolean {
    if (Number(PhoneInput.value.length) === 0 || !Boolean(validatePhone.test(PhoneInput.value))) {
      PhoneInput.HandleWarning('Please enter a valid phone number');
      PhoneInput.HandleStatus('error');
      return false;
    } else {
      PhoneInput.HandleWarning('');
      PhoneInput.HandleStatus('normal');
      return true;
    }
  }

  function validatedCity(): boolean {
    if (Number(CityInput?.value?.length) === 0 || !Boolean(validateInput.test(CityInput.value))) {
      CityInput.HandleWarning('Please enter a valid city');
      CityInput.HandleStatus('error');
      return false;
    } else {
      CityInput.HandleWarning('');
      CityInput.HandleStatus('normal');
      return true;
    }
  }

  function validatedOrgType(): boolean {
    return orgType ? true : false;
  }

  function validatedOrg(): boolean {
    if (Number(OrganizationInput.value.length) === 0 || !Boolean(validateAlphaNumeric.test(OrganizationInput.value))) {
      OrganizationInput.HandleWarning('Please enter a valid org name');
      OrganizationInput.HandleStatus('error');
      return false;
    } else {
      OrganizationInput.HandleWarning('');
      OrganizationInput.HandleStatus('normal');
      return true;
    }
  }
  function formFilledCoach(): void {
    if (FNameInput.value && LNameInput.value && EmailInput.value && PhoneInput.value) {
      useFormFilled(true);
    } else {
      useFormFilled(false);
    }
  }
  function formFilledOrg(): void {
    if (FNameInput.value && LNameInput.value && EmailInput.value && PhoneInput.value && OrganizationInput.value) {
      useFormFilled(true);
    } else {
      useFormFilled(false);
    }
  }

  async function BuildStates() {
    const result = await TEAMS.GetStates();
    if (result.status) {
      useDefaultStates(result.data);
    }
  }

  function ChangeStates(selectedOption: any) {
    useStates(selectedOption);
  }

  function ChangeImage(selectedOption: any) {
    useImage(selectedOption);
  }

  function ChangePallette(selectedOption: any) {
    usePallette(selectedOption);
  }

  function handleUploadTeamLogo() {
    teamLogoRef.current.click();
    teamLogoRef.current.onchange = () => ChangeImage(teamLogoRef.current.files[0]);
  }

  function DeleteTeamLogo() {
    ChangeImage('null');
  }

  function HandleFocus(input: any) {
    input.HandleWarning('');
    input.HandleStatus('normal');
  }

  async function handleDone() {
    if (!error && formFilled) {
      let resultImage: any;
      if (image && image !== 'null') {
        const uploadImage = await utils.UploadFile(image);
        resultImage = uploadImage.data.path;
      } else {
        resultImage = image === 'null' ? image : '';
      }
      const initials = user.role === 'org-admin' ? TeamBadge.value : '';
      const color = user.role === 'org-admin' ? pallette.color : '';
      const name = user.role === 'org-admin' ? OrganizationInput.value : '';
      const form = {
        firstName: FNameInput.value,
        lastName: LNameInput.value,
        orgName: name,
        email: EmailInput.value,
        orgType2: orgType.name,
        city: CityInput.value,
        state: states.name,
        phone: PhoneInput.value,
        color: color,
        initials: initials,
        image: resultImage,
      };
      useLoading(true);
      const response: any = await AUTH.UpdateSettings(
        form.firstName,
        form.lastName,
        form.orgName,
        form.email,
        form.orgType2,
        form.city,
        form.state,
        form.phone,
        form.color,
        form.initials,
        form.image,
      );

      if (response.status) {
        const updatedUser: any = await USER.GetUserData();
        if (updatedUser.status) {
          useLoading(false);
          HandleToastMessage(`UPDATED`, false, 2000, 'success');
          HandleUser(user, updatedUser.data);
        }
      } else {
        useLoading(false);
        HandleToastMessage(response.data.message, false, 2000, 'error');
      }
    }
  }

  function HandlePassword(value = !modal) {
    useModal(value);
  }

  function checkTrueUserImage(role): boolean {
    if (role === 'org-admin') {
      return user.data?.organization?.picture && user.data?.organization?.picture !== 'null';
    } else {
      return user.data?.picture && user.data?.picture !== 'null';
    }
  }

  function checkFalseUserImage(role): boolean {
    if (role === 'org-admin') {
      return user.data?.organization?.picture === 'null' || !user.data?.organization?.picture;
    } else {
      return user.data?.picture === 'null' || !user.data.picture;
    }
  }

  function VideoTourCallback(): any {
    setVideoTour(false)
    if (user.role === 'org-admin') {
      HandleToastMessage(`Welcome, please change the initial organization name`, false, 9000, 'success');
    }
  }
  const img = image && image !== 'null' ? URL.createObjectURL(image) : user?.data?.picture || user?.data?.organization?.picture;
  return (
    <>
      <Navbar />
      <ConfigWrapper data-cy="config">
        <FluidContainer>
          <ConfigCard>
            <TopWrapper>
              <ConfigCardLeft>
                {((image && image !== 'null') || (!image && checkTrueUserImage(user.role))) && (
                  <>
                    <CLeftBadges data-cy="badge-picture">
                      <BadgeImage srcImage={img} callback={DeleteTeamLogo} />
                    </CLeftBadges>
                    <CLeftActions empty={false}>
                      <input
                        data-cy="file-input"
                        ref={teamLogoRef}
                        type="file"
                        accept="image/png, image/jpeg"
                        style={{ display: 'none' }}
                      />
                      <LargeButton
                        callback={handleUploadTeamLogo}
                        rColor="#006BE1"
                        lColor="#007AFF"
                        icon="uploadImage"
                        title="UPLOAD NEW PHOTO"
                      />
                      <CLeftActionInfo>You can edit your profile picture or upload a new one (JPG or PNG)</CLeftActionInfo>
                    </CLeftActions>
                  </>
                )}
                {(image === 'null' || (!image && checkFalseUserImage(user.role))) && (
                  <>
                    {user.role === 'org-admin' && (
                      <>
                        <CLeftBadges>
                          <Badge
                            text={TeamBadge.value}
                            size="140px"
                            font="70px"
                            family="Proxima Nova"
                            color={pallette.color}
                            weight="500"
                          />
                        </CLeftBadges>
                        <CLeftInputs>
                          <CLeftInputSection>
                            <Label text="Color" />
                            <div>
                              <PowerDropdown
                                dataArray={DefaultPallette}
                                badge={pallette.badge}
                                colorBadge={pallette.color}
                                onClick={ChangePallette}
                                search={false}
                                mWidth="90%"
                                mPadding="2px 0 2px 10px"
                                mHeigth={'150px'}
                              />
                            </div>
                          </CLeftInputSection>
                          <CLeftInputSection>
                            <Label text="Initial" />
                            <div data-cy="initials">
                              <InputComponent placeholder="" animateWidth="100%" dynamicSearch={TeamBadge} maxLength={2} />
                            </div>
                          </CLeftInputSection>
                        </CLeftInputs>
                      </>
                    )}
                    {user.role === 'coach' && (
                      <CLeftBadges data-cy="badge-picture">
                        <BadgeImage srcImage={undefined} callback={DeleteTeamLogo} />
                      </CLeftBadges>
                    )}
                    <CLeftActions empty={true}>
                      <input
                        data-cy="file-input"
                        ref={teamLogoRef}
                        type="file"
                        accept="image/png, image/jpeg"
                        style={{ display: 'none' }}
                      />
                      <LargeButton
                        callback={handleUploadTeamLogo}
                        rColor="#ACB1C0"
                        lColor="#979CA9"
                        icon="uploadImage"
                        title={user.role === 'org-admin' ? 'UPLOAD ORGANIZATION LOGO' : 'UPLOAD PROFILE PICTURE'}
                      />
                      <CLeftActionInfo>You can edit your profile picture or upload a new one (JPG or PNG)</CLeftActionInfo>
                    </CLeftActions>
                  </>
                )}
              </ConfigCardLeft>
              <ConfigCardRight>
                <CRightTop>
                  <InputWrapper>
                    <Label text="First Name*" />
                    <CRightInputWrapper data-cy="firstname">
                      <InputComponent
                        placeholder={user.data?.firstname ? user.data.firstName : 'First Name'}
                        animateWidth="100%"
                        dynamicSearch={FNameInput}
                        HandleFocus={() => HandleFocus(FNameInput)}
                      />
                    </CRightInputWrapper>
                    {FNameInput.warningMessage && <ToolTip theme={'dark'} title={'Check this field'} text={FNameInput.warningMessage} />}
                  </InputWrapper>
                  <InputWrapper>
                    <Label text="Last Name*" />
                    <CRightInputWrapper data-cy="lastname">
                      <InputComponent
                        placeholder={user.data?.lastname ? user.data.lastName : 'Last Name'}
                        animateWidth="100%"
                        dynamicSearch={LNameInput}
                        HandleFocus={() => HandleFocus(LNameInput)}
                      />
                    </CRightInputWrapper>
                    {LNameInput.warningMessage && <ToolTip theme={'dark'} title={'Check this field'} text={LNameInput.warningMessage} />}
                  </InputWrapper>
                  <InputWrapper>
                    <Label text="Email*" />
                    <CRightInputWrapper data-cy="email">
                      <InputComponent
                        placeholder={user.data?.email ? user.data.email : 'Email'}
                        animateWidth="100%"
                        dynamicSearch={EmailInput}
                        maxLength={100}
                        HandleFocus={() => HandleFocus(EmailInput)}
                      />
                    </CRightInputWrapper>
                    {EmailInput.warningMessage && <ToolTip theme={'dark'} title={'Check this field'} text={EmailInput.warningMessage} />}
                  </InputWrapper>
                  <InputWrapper>
                    <Label text="Phone*" />
                    <CRightInputWrapper data-cy="phone">
                      <InputComponent
                        placeholder={user.data?.phone ? user.data.phone : 'E.g: +1 xxx xxx xxxx'}
                        animateWidth="100%"
                        dynamicSearch={PhoneInput}
                        HandleFocus={() => HandleFocus(PhoneInput)}
                      />
                    </CRightInputWrapper>
                    {PhoneInput.warningMessage && <ToolTip theme={'dark'} title={'Check this field'} text={PhoneInput.warningMessage} />}
                  </InputWrapper>
                  <InputWrapper>
                    <Label text="City*" />
                    <CRightInputWrapper data-cy="city">
                      <InputComponent
                        placeholder={user.data?.city ? user.data.city : 'City'}
                        animateWidth="100%"
                        dynamicSearch={CityInput}
                        maxLength={100}
                        HandleFocus={() => HandleFocus(CityInput)}
                      />
                    </CRightInputWrapper>
                    {CityInput.warningMessage && <ToolTip theme={'dark'} title={'Check this field'} text={CityInput.warningMessage} />}
                  </InputWrapper>
                  <InputWrapper>
                    <Label text="State*" />
                    <CRightInputWrapper>
                      <PowerDropdown
                        mHeigth={'200px'}
                        dataArray={defaultStates}
                        primaryTitle={states.name}
                        onClick={ChangeStates}
                        search={false}
                        mWidth="96%"
                        mPadding="2px 0 2px 10px"
                      />
                    </CRightInputWrapper>
                    {!Boolean(states?.name?.length) && (
                      <ToolTip theme={'dark'} title={'Check this field'} text={'Please enter a state'} />
                    )}
                  </InputWrapper>
                  {user.role === 'org-admin' ? (
                    <>
                      <InputWrapper>
                        <Label text="Organization Type*" />
                        <CRightInputWrapper data-cy="organization-type">
                          <PowerDropdown
                            mHeigth={'200px'}
                            dataArray={DEFAULT_ORG_TYPES}
                            primaryTitle={orgType.name ? orgType.name : 'Select'}
                            onClick={useOrgType}
                            search={false}
                            mWidth="96%"
                            mPadding="2px 0 2px 10px"
                          />
                        </CRightInputWrapper>
                      </InputWrapper>
                      <InputWrapper>
                        <Label text="Organization Name*" />
                        <CRightInputWrapper data-cy="org-name">
                          <InputComponent
                            placeholder={
                              user.data?.isFirstLogin
                                ? 'Organization Name'
                                : user.data.organization.name
                                  ? user.data.organization.name
                                  : 'Organization Name'
                            }
                            animateWidth="100%"
                            dynamicSearch={OrganizationInput}
                            HandleFocus={() => HandleFocus(OrganizationInput)}
                          />
                        </CRightInputWrapper>
                        {OrganizationInput.warningMessage && (
                          <ToolTip theme={'dark'} title={'Check this field'} text={OrganizationInput.warningMessage} />
                        )}
                      </InputWrapper>
                    </>
                  ) : (
                    <></>
                  )}

                  <div>
                    <CRightPasswordWrapper>
                      <Label text="Password*" />
                      <Label text="Change Password" color="#007AFF" decoration="underline" cursor="pointer" callback={HandlePassword} />
                    </CRightPasswordWrapper>
                    <CRightInputWrapper>
                      <InputComponent placeholder="******" animateWidth="100%" dynamicSearch={PasswordInput} />
                    </CRightInputWrapper>
                  </div>
                </CRightTop>
              </ConfigCardRight>
            </TopWrapper>
            <BottomWrapper>
              {formFilled && !error ? (
                !loading ? (
                  <CRightBottom>
                    <LargeButton callback={handleDone} rColor="#FF3B30" lColor="#E1342A" icon="done" title="SAVE PROFILE" />
                  </CRightBottom>
                ) : (
                  <CRightBottom>
                    <Loader width="186px" height="50px" />
                  </CRightBottom>
                )
              ) : (
                <></>
              )}
            </BottomWrapper>
          </ConfigCard>
        </FluidContainer>
      </ConfigWrapper>
      {modal && (
        <Modal title="Change Password" margin="12vh auto 200px auto">
          <PasswordModal handleView={HandlePassword} />
        </Modal>
      )}
      {isVideoTour && (
        <VideoTourModal callback={VideoTourCallback} />
      )}
    </>
  );
};
